import React from "react";
import Link from "next/link";
import styles from "./section_booking.module.scss";

export const UniPageBookingSection = (props) => {
  return (
    <section className={styles.section_mentor_join}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.title}>
            Join Us Today to Access Over 1,500,000 Prospects from Promising
            Student Markets
          </h2>
          {/* <p className={styles.description}>
            Our innovative approach to student recruitment uses data-driven
            technologies and market insight with two main outcomes for our
            university partners: simplify and succeed. Attract the best
            prospects from your target markets today through UniSearch’s
            efficient, intelligent systems.
          </p> */}
          <Link legacyBehavior href="/university/booking">
            <a className={`${styles.link_btn} btn btn-white btn-bg`}>
              Book for Demo
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UniPageBookingSection;
